import axios, {AxiosResponse} from 'axios';

export type TMarketingContact = {
  email: string;
};

const post = ({email}: TMarketingContact): Promise<AxiosResponse> => {
  const source = axios.CancelToken.source();
  return axios.post(
    '//links.iterable.com/lists/publicAddSubscriberForm?publicIdString=2bfdb6fb-d73e-4701-a625-534d946a6f29',
    {
      emailListId: '4924396',
      email,
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      cancelToken: source.token,
    }
  );
};

export default {
  post,
};
